import React from 'react';

import styles from './ReferralForm.module.css';
import { ReferralWidget } from './ReferralWidget';
import { useViralLoop } from './useViralLoop';

import type { ReactElement } from 'react';

type Props = {
  campaignId: string;
  email?: string;
  firstName?: string;
  lastName?: string;
};

export const ReferralForm = ({ campaignId, email, firstName, lastName }: Props): ReactElement => {
  const user = useViralLoop({ campaignId, email, firstName, lastName });

  return (
    <div className={styles.root}>
      {!user ? <div>Loading...</div> : <ReferralWidget campaignId={campaignId} />}
    </div>
  );
};
